export const SvieziapieniuMarks = [
  { value: 45, label: "45" },
  { value: 60, label: "60" },
  { value: 75, label: "75" },
  { value: 90, label: "90" },
];

export const SvieziapieniuProcentuMarks = [
  { value: 20, label: "20" },
  { value: 25, label: "25" },
  { value: 30, label: "30" },
  { value: 35, label: "35" },
  { value: 40, label: "40" },
];

export const LaktacijosTrukmeDienomis = [
  { value: 0, label: "0" },
  { value: 100, label: "100" },
  { value: 200, label: "200" },
  { value: 300, label: "300" },
  { value: 400, label: "400" },
  { value: 500, label: "500" },
  { value: 600, label: "600" },
  { value: 700, label: "700" },
  { value: 800, label: "800" },
  { value: 900, label: "900" },
  { value: 1000, label: "1000" },
];

export const LaktacijosTrukmeDienomisIlgesnis = [
  { value: 0, label: "0" },
  { value: 200, label: "200" },
  { value: 400, label: "400" },
  { value: 600, label: "600" },
  { value: 800, label: "800" },
  { value: 1000, label: "1000" },
  { value: 1200, label: "1200" },
  { value: 1400, label: "1400" },
  { value: 1600, label: "1600" },
  { value: 1800, label: "1800" },
  { value: 2000, label: "2000" },
];

export const LaktacijosTrukmeDienomisMazesne = [
  { value: 0, label: "0" },
  { value: 250, label: "250" },
  { value: 500, label: "500" },
  { value: 750, label: "750" },
  { value: 1000, label: "1000" },
];

export const LaktacijosTrukmeDienomisMazesneDaugiauDieniu = [
  { value: 0, label: "0" },
  { value: 250, label: "250" },
  { value: 500, label: "500" },
  { value: 750, label: "750" },
  { value: 1000, label: "1000" },
  { value: 1250, label: "1250" },
  { value: 1500, label: "1500" },
  { value: 1750, label: "1750" },
  { value: 2000, label: "2000" },
];

export const MenesiaiAtgal = [
  { value: 1, label: "1 mėn." },
  { value: 2, label: "" },
  { value: 3, label: "3 mėn." },
  { value: 4, label: "" },
  { value: 5, label: "" },
  { value: 6, label: "6 mėn." },
  { value: 7, label: "" },
  { value: 8, label: "" },
  { value: 9, label: "9 mėn." },
  { value: 10, label: "" },
  { value: 11, label: "" },
  { value: 12, label: "12 mėn." },
];

export const MenesiaiAtgalMazesnis = [
  { value: 1, label: "1 mėn." },
  { value: 2, label: "" },
  { value: 3, label: "" },
  { value: 4, label: "" },
  { value: 5, label: "" },
  { value: 6, label: "6 mėn." },
  { value: 7, label: "" },
  { value: 8, label: "" },
  { value: 9, label: "" },
  { value: 10, label: "" },
  { value: 11, label: "" },
  { value: 12, label: "12 mėn." },
];
